import { redirect } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { authMe } from "@/api/auth";
import { httpStatus } from "@/api/client";

/**
 * Shared `/auth/me` query used by every authenticated route's loader
 * and component, so the session is fetched once and cached.
 */
export const meQuery = {
  queryKey: ["me"] as const,
  queryFn: authMe,
  staleTime: 60_000,
};

/**
 * Loader guard for authenticated routes. Redirects to the landing
 * page ONLY on 401/403 (genuinely unauthenticated). A transient
 * failure (network, 5xx) re-throws so the router's error boundary
 * shows — a signed-in user hitting a blip must not be bounced to the
 * login screen.
 */
export const requireAuth = async (queryClient: QueryClient) => {
  try {
    return await queryClient.ensureQueryData(meQuery);
  } catch (err) {
    const status = httpStatus(err);
    if (status === 401 || status === 403) {
      throw redirect({ to: "/" });
    }
    throw err;
  }
};
